export default "__VITE_ASSET__5ffb45c8__"